module.exports = __webpack_public_path__ + "static/insert_mini_calendar_after-0bac1aeb4eecc15f8a8ae112dffc34d3.png";